// src/pages/Reports.js
import React, { useEffect, useState } from 'react';
import api from '../utils/api';
import { useAuth } from '../contexts/AuthContext';

export default function Reports() {
  const { user } = useAuth();
  const [data, setData] = useState([]);
  const [depts, setDepts] = useState([]);
  const [filters, setFilters] = useState({ dept_code:'', from_date:'', to_date:'' });
  const [loading, setLoading] = useState(false);

  useEffect(() => { api.get('/departments').then(r => setDepts(r.data)); }, []);

  const load = async () => {
    setLoading(true);
    const params = new URLSearchParams(filters);
    const { data: d } = await api.get(`/export/reports/summary?${params}`);
    setData(d);
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const totals = data.reduce((a,r) => ({
    forms: a.forms + parseInt(r.total_forms||0),
    employees: a.employees + parseInt(r.total_employees||0),
    children: a.children + parseInt(r.total_children||0),
  }), { forms:0, employees:0, children:0 });

  return (
    <div style={styles.page}>
      <h1 style={styles.title}>📈 ڕاپۆرتەکان</h1>
      
      <div style={styles.filterBox}>
        {user?.role === 'admin' && (
          <select style={styles.sel} value={filters.dept_code} onChange={e=>setFilters({...filters,dept_code:e.target.value})}>
            <option value="">هەموو بەشەکان</option>
            {depts.map(d=><option key={d.id} value={d.code}>{d.name_ku}</option>)}
          </select>
        )}
        <input type="date" style={styles.sel} value={filters.from_date} onChange={e=>setFilters({...filters,from_date:e.target.value})} />
        <input type="date" style={styles.sel} value={filters.to_date} onChange={e=>setFilters({...filters,to_date:e.target.value})} />
        <button onClick={load} style={styles.btn}>🔍 گەڕان</button>
      </div>

      <div style={styles.statCards}>
        {[
          {label:'کۆی فۆرمەکان', value:totals.forms, icon:'📋', color:'#1a5276'},
          {label:'کارمەندەکان', value:totals.employees, icon:'👤', color:'#1e8449'},
          {label:'کۆی منداڵ', value:totals.children, icon:'👶', color:'#7d3c98'},
        ].map((c,i)=>(
          <div key={i} style={{...styles.statCard, borderTop:`4px solid ${c.color}`}}>
            <div style={{fontSize:28}}>{c.icon}</div>
            <div style={{fontSize:24,fontWeight:'bold',color:c.color}}>{c.value}</div>
            <div style={{fontSize:12,color:'#888'}}>{c.label}</div>
          </div>
        ))}
      </div>

      <div style={styles.tableWrap}>
        {loading ? <div style={{textAlign:'center',padding:30}}>چاوەڕوانبە...</div> : (
          <table style={styles.table}>
            <thead><tr style={styles.thead}>
              <th style={styles.th}>کۆدی بەش</th>
              <th style={styles.th}>ناوی بەش</th>
              <th style={styles.th}>فۆرمەکان</th>
              <th style={styles.th}>کارمەندەکان</th>
              <th style={styles.th}>منداڵەکان</th>
            </tr></thead>
            <tbody>
              {data.map((r,i)=>(
                <tr key={i} style={styles.tr}>
                  <td style={styles.td}><span style={styles.code}>{r.code}</span></td>
                  <td style={styles.td}>{r.dept}</td>
                  <td style={styles.td}>{r.total_forms}</td>
                  <td style={styles.td}>{r.total_employees}</td>
                  <td style={styles.td}>{r.total_children || 0}</td>
                </tr>
              ))}
              {data.length===0 && <tr><td colSpan={5} style={{textAlign:'center',padding:30,color:'#999'}}>داتا نیە</td></tr>}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

const styles = {
  page:{padding:20}, title:{fontSize:20,fontWeight:'bold',color:'#1a5276',marginBottom:16},
  filterBox:{display:'flex',gap:10,marginBottom:20,flexWrap:'wrap'},
  sel:{padding:'8px 12px',border:'1.5px solid #ddd',borderRadius:8,fontSize:13,fontFamily:'inherit'},
  btn:{background:'#1a5276',color:'#fff',border:'none',borderRadius:8,padding:'8px 20px',cursor:'pointer',fontSize:13},
  statCards:{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(150px,1fr))',gap:16,marginBottom:20},
  statCard:{background:'#fff',borderRadius:10,padding:20,textAlign:'center',boxShadow:'0 2px 8px rgba(0,0,0,0.08)'},
  tableWrap:{background:'#fff',borderRadius:10,overflow:'hidden',boxShadow:'0 2px 8px rgba(0,0,0,0.07)'},
  table:{width:'100%',borderCollapse:'collapse'},
  thead:{background:'#1a5276'}, th:{color:'#fff',padding:'11px 12px',textAlign:'right',fontSize:12},
  tr:{borderBottom:'1px solid #f0f0f0'}, td:{padding:'10px 12px',fontSize:13},
  code:{background:'#eaf2fb',color:'#1a5276',borderRadius:4,padding:'2px 8px',fontSize:11,fontWeight:'bold'},
};
